import { cva } from 'class-variance-authority';

export const headingMoleculeContainer = cva('grid', {
  variants: {
    alignment: {
      centerWide: 'm-auto w-full max-w-[1200px] grid-cols-1 text-left sm:place-items-center sm:text-center',
      center: 'm-auto max-w-[960px] grid-cols-1 text-left sm:place-items-center sm:text-center',
      left: 'grid-cols-1',
      leftInline: 'w-full grid-cols-1 lg:grid-cols-2 lg:gap-x-[75px]',
    },
    size: {
      sm: 'gap-4',
      lg: 'gap-6',
    },
    isForm: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      isForm: true,
      size: 'sm',
      className: 'gap-3 sm:gap-3',
    },
    {
      isForm: true,
      size: 'lg',
      className: 'gap-4 sm:gap-4',
    },
    {
      isForm: false,
      size: 'sm',
      className: 'gap-4',
    },
    {
      isForm: false,
      size: 'lg',
      className: 'gap-6',
    },
  ],
  defaultVariants: {
    size: 'sm',
    isForm: false,
  },
});

export const headingStyles = cva('col-start-1 font-semibold text-heading', {
  variants: {
    size: {
      sm: 'text-display-sm dark:text-white sm:text-display-lg',
      lg: 'text-display-md dark:text-heading-gradient sm:text-display-lg lg:text-display-xl',
    },
    isForm: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    size: 'sm',
    isForm: false,
  },
});

export const bodyStyles = cva('text-lg font-medium text-gray-700 dark:text-gray-300 sm:text-xl', {
  variants: {
    alignment: {
      centerWide: '',
      center: '',
      left: '',
      leftInline: 'lg:col-start-2',
    },
    hasEyebrow: {
      true: '',
      false: '',
    },
    isForm: {
      true: 'text-xl leading-normal',
      false: '',
    },
  },
  compoundVariants: [
    {
      hasEyebrow: true,
      alignment: 'leftInline',
      className: 'lg:row-start-2',
    },
    {
      hasEyebrow: false,
      alignment: 'leftInline',
      className: 'lg:row-start-1',
    },
  ],
  defaultVariants: {
    isForm: false,
  },
});
